// New translations for registration and email confirmation
const newTranslations = {
    // OTP password reset
    'send_code': 'Siųsti kodą',
    'verification_code': 'Patvirtinimo kodas',
    'verify_code': 'Patvirtinti kodą',
    'otp_sent': 'Patvirtinimo kodas išsiųstas į jūsų el. paštą!',
    'otp_resent': 'Naujas kodas išsiųstas!',
    'invalid_otp': 'Neteisingas kodas. Bandykite dar kartą.',
    'enter_6_digit_code': 'Įveskite 6 skaičių kodą',
    'otp_verification_desc': 'Įveskite gautą 6 skaičių kodą',
    'resend_code_in': 'Siųsti kodą iš naujo galėsite po',
    'resend_code': 'Siųsti kodą iš naujo',
    // reCAPTCHA
    'recaptcha_required': 'Prašome patvirtinti, kad nesate robotas',
    // Registration and auth
    'registracija_sekme': 'Registracija sėkminga!',
    'vardas': 'Vardas',
    'pavarde': 'Pavardė',
    'ivestiVarda': 'Įveskite vardą',
    'ivestiPavarde': 'Įveskite pavardę',
    'slaptazodzio_keitimas': 'Slaptažodžio keitimas',
    'current_password': 'Dabartinis slaptažodis',
    'neteisingas_dabartinis_slaptazodis': 'Neteisingas dabartinis slaptažodis',
    'profilis_atnaujintas': 'Profilis sėkmingai atnaujintas!',
    'keisti_slaptazodi': 'Keisti',
    'slaptazodzio_keitimo_aprasymas': 'Slaptažodžio keitimui atsiųsime nuorodą        ',
    'slaptazodzio_keitimo_nuoroda_issiusta': 'Nuoroda slaptažodžio keitimui išsiųsta',
    'registracijos_klaida': 'Vartotojas šiuo el. paštu jau užregistruotas arba nepatvirtintas', // Atnaujintas vertimas
    'sistemos_klaida': 'Įvyko sistemos klaida. Prašome bandyti vėliau.',
    'registruojama': 'Registruojama...',
    'privalomi_laukai': 'Užpildykite visus privalomus laukus',
    'prisijungimo_klaida': 'Nepavyko prisijungti. Jūsų paskyra nepatvirtinta adinistratoriaus arba patikrinkite el. paštą ir slaptažodį.',
    'jungiamasi': 'Jungiamasi...',
    'user_exists': 'Vartotojas šiuo el. paštu jau užregistruotas arba nepatvirtintas', // Naujas vertimas
    'esu_organizacijos_atstovas': 'Esu įgaliotas organizacijos atstovas ir galiu organizacijos vardu kurti paskyrą', // Naujas vertimas
    
    // Email confirmation
    'email_patvirtinimas': 'El. pašto patvirtinimas',
    'tikrinamas_email': 'Tikrinamas jūsų el. pašto patvirtinimas...',
    'email_patvirtintas': 'Jūsų el. paštas sėkmingai patvirtintas!',
    'email_patvirtintas_sekmes': 'El. paštas sėkmingai patvirtintas! Dabar administratorius turi patvirtinti jūsų paskyrą.',
    'email_patvirtintas_admin': 'Administratorius turi patvirtinti jūsų paskyrą, kad galėtumėte naudotis sistema. Tai gali užtrukti iki 24 val.',
    'patvirtinimo_klaida': 'Įvyko klaida patvirtinant el. paštą.',
    'truksta_parametru': 'Trūksta reikalingų patvirtinimo parametrų.',
    'netinkamas_patvirtinimo_tipas': 'Netinkamas patvirtinimo tipas. Bandykite dar kartą.',
    'grizti_i_prisijungima': 'Grįžti į prisijungimo puslapį',
    
    // Admin confirmation
    'laukiama_admin_patvirtinimo': 'Jūsų paskyra laukia administratoriaus patvirtinimo',
    'jūsų_paskyra_laukia_administratoriaus_patvirtinimo': 'Jūsų el. paštas sėkmingai patvirtintas, tačiau prieš naudojantis sistema jūsų paskyrą turi patvirtinti administratorius.',
    'gauti_patvirtinimą_gali_užtrukti_iki_24_val': 'Patvirtinimo procesas gali užtrukti iki 24 val. Patvirtinus paskyrą, gausite pranešimą el. paštu.',
    'account_not_confirmed_by_admin': 'Jūsų paskyra dar nepatvirtinta administratoriaus. Galėsite naudotis sistema, kai administratorius patvirtins jūsų paskyrą.',
    
    // Admin guide
    'vartotojų_patvirtinimas': 'Vartotojų patvirtinimas',
    'nauji_vartotojai_turi_būti_patvirtinti_prieš_naudojimą': 'Nauji vartotojai turi būti patvirtinti prieš galėdami naudotis sistema.',
    'patvirtinti_vartotojai_gali_prisijungti_ir_naudotis_sistema': 'Patvirtinti vartotojai gali prisijungti ir naudotis sistema.',
    'nepatvirtinti_vartotojai_negali_prisijungti': 'Nepatvirtinti vartotojai negali pilnai naudotis sistema.',
    'vartotojai_kurių_el_paštas_nepatvirtintas_gali_neturėti_prieigos': 'Vartotojai, kurių el. paštas nepatvirtintas, negali prieiti prie sistemos.',
    
    // Registration success
    'registration_success_email_confirmation': 'Registracija sėkminga! Patikrinkite savo el. paštą, kad patvirtintumėte paskyrą.',
    
    // OTP Password Reset translations
    'send_verification_code': 'Siųsti patvirtinimo kodą',
    'verification_code': 'Patvirtinimo kodas',
    'otp_sent': 'Patvirtinimo kodas išsiųstas į jūsų el. paštą',
    'enter_verification_code': 'Įveskite 6 skaitmenų kodą iš el. pašto',
    'verify_code': 'Patvirtinti kodą',
    'invalid_otp': 'Neteisingas arba pasibaigęs patvirtinimo kodas',
    'otp_verified': 'Kodas sėkmingai patvirtintas',
    'otp_required': 'Prašome įvesti 6 skaitmenų kodą',
    'resend_code': 'Siųsti kodą dar kartą',
    'enter_new_password': 'Įveskite naują slaptažodį',
    'new_password': 'Naujas slaptažodis',
    'confirm_password': 'Patvirtinti slaptažodį',
    'password_required': 'Slaptažodis yra privalomas',
    'passwords_dont_match': 'Slaptažodžiai nesutampa',
    'password_too_short': 'Slaptažodis turi būti bent 6 simbolių',
    'password_updated': 'Slaptažodis sėkmingai atnaujintas',
    'password_update_failed': 'Nepavyko atnaujinti slaptažodžio',
    'update_password': 'Atnaujinti slaptažodį',
    
    // Two-step confirmation translations
    'confirm_password_reset': 'Patvirtinti slaptažodžio atstatymą',
    'click_below_to_reset_password': 'Spustelėkite mygtuką žemiau, kad tęstumėte slaptažodžio atstatymą.',
    'link_expires_warning': 'Ši nuoroda galioja tik vieną kartą arba 1 valandą.',
    'confirm_reset': 'Patvirtinti atstatymą',
    'cancel': 'Atšaukti',
    'security_notice': 'Šis papildomas žingsnis padeda apsaugoti jūsų paskyrą nuo neteistos prieigos.',
    'invalid_reset_link': 'Neteisinga slaptažodžio atstatymo nuoroda',
    'reset_link_error': 'Klaida apdorojant atstatymo nuorodą',
    'invalid_link': 'Neteisinga nuoroda',
    'redirecting': 'Nukreipiama',
    
    // Company confirmation
    'patvirtinti_imone': 'Patvirtinti įmonę',
    'Vartotojas sėkmingai patvirtintas': 'Įmonė sėkmingai patvirtinta!',
    'Klaida patvirtinant vartotoją': 'Klaida patvirtinant įmonę. Bandykite dar kartą.',

    // Subscription
    'galioja_iki': 'Galioja iki',
    'galiojanti': 'Galiojanti',
    'negaliojanti': 'Negaliojanti',
    'prenumeratos_info': 'Pasirinkite prenumeratos tipą ir išsaugokite pakeitimus',
    'Įmonė sėkmingai patvirtinta!': 'Įmonė sėkmingai patvirtinta!',
    'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.': 'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.',
    'login_error': 'Slaptažodis neteisingas arba paskyra nepatvirtinta',
    'db_migration_info': 'Jeigu dar nepakeitėte slaptažodžio, prašome paspausti "Pamiršai slaptažodį" ir mes jums atsiųsime nuorodą slaptažodžio keitimui. Buvo migruojama duomenų bazė į kitus serverius, tad jums reikia susikurti naują slaptažodį.',
    
    // Slaptažodžio atkūrimo vertimų papildymai
    'reset_link_sent': 'Slaptažodžio atstatymo nuoroda išsiųsta',
    'reset_link_sent_desc': 'Slaptažodžio atstatymo nuoroda išsiųsta į jūsų el. paštą. Patikrinkite savo pašto dėžutę.',
    'prasyti_atstatymo': 'Atstatyti slaptažodį',
    'grizti_i_prisijungima': 'Grįžti į prisijungimą',
    'tikrinama_sesija': 'Tikrinama sesija...',
    'slaptazodis_pakeistas_aprasas': 'Jūsų slaptažodis sėkmingai pakeistas. Dabar galite prisijungti su nauju slaptažodžiu.',
    'keitimas_uztruko': 'Slaptažodžio keitimas užtruko per ilgai. Bandykite dar kartą arba kreipkitės į administratorių.',
    'processing': 'Apdorojama...',
    'forgotPass.invalidEmail': 'Neteisingas el. pašto formatas',
    'forgotPass.resetLinkSent': 'Slaptažodžio atkūrimo nuoroda išsiųsta',
    'forgotPass.resetError': 'Klaida siunčiant atkūrimo nuorodą',
    'ivestkiteEmail': 'Įveskite teisingą el. paštą',
    
    // Įmonių valdymo vertimai
    'laukia_patvirtinimo': 'Laukia patvirtinimo',
    'aktyvi': 'Aktyvi',
    'pasibaigusi': 'Pasibaigusi',
    'patvirtinta': 'Patvirtinta',
    'nepatvirtinta': 'Nepatvirtinta',
    'neribota': 'Neribota',
    'paspauskite_patvirtinti_kad_aktyvuoti': 'Paspauskite "Patvirtinti įmonę" mygtuką',
    'pakeitimai_issaugoti': 'Pakeitimai išsaugoti!',
    'prideti_metus': 'Pratęsti metus'
};

export default newTranslations;
